import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Row,
  Typography,
  Card,
  Form,
  Spin,
  Col,
  Divider,
  Input,
  message,
  List,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//PROJECT IMPORTS
// import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "./productMix.config";

const { Text, Title } = Typography;

const NewProductMix = (props) => {
  //DECLARED VARIABLES
  const {
    userData,
  } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [productDetail, setProductDetail] = useState([]);
  const [allowedProductData, setAllowedProductData] = useState([]);
  const [restrictedProductsData, setRestrictedProductsData] = useState([]);
  const [inputField, setInputField] = useState([]);

  useEffect(() => {
    getDetailById();
  }, []);

  const getDetailById = () => {
    setIsLoading(true);
    const url = `${apiConfig.Loanproducts}/${state.id}/productmix`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setProductDetail(objDetail);
        setInputField([
          {
            name: labelConfig.productMixId,
            value: objDetail.productId,
          },
          {
            name: labelConfig.productName,
            value: objDetail.productName,
          },
        ]);

        const tempAllowedProd = [];
        const tempRestrictedProd = [];

        objDetail?.allowedProducts?.forEach((element) => {
          tempAllowedProd.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.restrictedProducts?.forEach((element) => {
          tempRestrictedProd.push({
            value: element.id,
            label: element.name,
          });
        });

        setAllowedProductData(tempAllowedProd);
        setRestrictedProductsData(tempRestrictedProd);

        // ENABLE DELETE BUTTON
        {BOM.HasPermission("DELETE_PRODUCTMIX") && dispatch({type: cnt.RIGHT_DELETE_BTN})};
        setIsLoading(false);
      }
    });
  };

  const handleOnDelete = () => {
    let action = "Delete  ";
    let label = productDetail.productName;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${apiConfig.Loanproducts}/${productDetail.productId}/productmix`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteProductMixMsg);
            navigate("/prd0606");
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },
      function () {
        // No button
      }
    );
  };
  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      <TopContent
        pageTitle={labelConfig.productMixDetail}
        pageItems={staticConfig.detailBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form initialValues={{}} form={form} layout="vertical">
            {/* <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {`${productDetail.productName} ( ${productDetail.productId} )`}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} /> */}
            <Row>
              <Divider orientation="left" orientationMargin="0">
                {labelConfig.generalInfo}
              </Divider>

              {inputField.map((item, index) => (
                <Col span={8} style={{ padding: "0px 8px" }} key={index}>
                  <Form.Item label={<Text strong>{item.name}</Text>}>
                    <Input disabled value={item.value} />
                  </Form.Item>
                </Col>
              ))}
            </Row>
            <Row>
              <Divider orientation="left" orientationMargin="0">
                {labelConfig.loanAccountsInfo}
              </Divider>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <List
                style={{
                  height: "40vh",
                  overflowY:'auto'
                }}
                  header={<div>{labelConfig.allowedProducts}</div>}
                  bordered
                  dataSource={allowedProductData}
                  renderItem={(item) => (
                    <List.Item>
                      <Typography.Text mark>{item.label}</Typography.Text>{" "}
                     {/* ( {item.value}) */}
                    </List.Item>
                  )}
                />
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <List
                  header={<div>{labelConfig.restrictedProducts}</div>}
                  bordered
                  style={{
                    height: "40vh",
                    overflowY:'auto'
                  }}
                  dataSource={restrictedProductsData}
                  renderItem={(item) => (
                    <List.Item>
                      <Typography.Text mark>{item.label}</Typography.Text>{" "}
                     {/* ( {item.value}) */}
                    </List.Item>
                  )}
                />
              </Col>
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(NewProductMix);
